import React from 'react'
import { useNavigation } from '@react-navigation/core'
import { RouteProp, useRoute } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NavigationContainer } from '@src/screens/Common/containers'
import { AppStackParamList } from '@src/navigation/types'
import { ModuleComponent } from '../components/Module'
import { LessonWithContent } from '../models/courses.types'
import { useModule } from '../hooks'

const navigationBarProps = { backgroundColor: 'transparent' }

export const ModuleContainer = () => {
  const styles = useStyleSheet(themedStyle)

  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const { params } = useRoute<RouteProp<AppStackParamList, 'CoursesModule'>>()
  const { module, lessons, isLoading } = useModule(params)

  const onLessonPress = (lesson: LessonWithContent) => {
    if (params.locked) {
      return
    }

    const screen = lesson.isExperiment ? 'CoursesExperiment' : 'CoursesLesson'
    navigation.navigate(screen, { lesson, parentScreenParams: params })
  }

  return (
    module && (
      <NavigationContainer
        title={module.title}
        goBack={navigation.goBack}
        style={styles.navbar}
        navigationBarProps={navigationBarProps}
      >
        <ModuleComponent
          module={module}
          lessons={lessons}
          isLoading={isLoading}
          locked={params.locked}
          onLessonPress={onLessonPress}
        />
      </NavigationContainer>
    )
  )
}

const themedStyle = StyleService.create({
  navbar: {
    flex: 1,
    backgroundColor: 'theme.background',
  },
})
